export const 
  EMAIL_ADDRESS = "admin@managemybookkeeping.com.au"
  // PHONE_NUMBER = "0438 735 650"

export const API_URL = process.env.REACT_APP_API_URL;